import React from 'react'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import '../App.css';


import 'animate.css';
const Contact = () => {

  const { t } = useTranslation();

  const form = useRef();
 
  const sendEmail = (e) => {
    alert("message sent successfully")
    e.preventDefault();
    emailjs.sendForm('service_qwouz0h', 'template_4x5hi4c', form.current, 'XuWAXvKXOk8xL4R1F')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
    e.target.reset()
  };
  return (
    <section className="homesec6" id="contact">
        <Container>
          <h3 className="wow fadeIn" data-wow-duration="2s" data-wow-delay="0.1s">{t("contact")}</h3>
          <Row className="align-items-center">
            <Col md={6} sm={12} className="wow slideInLeft" data-wow-duration="2s" data-wow-delay="0.1s">
              <div>
                <p><span>{t("email")} :</span> info@gmbplast.com</p>
                <p><span>{t("phone")}</span> +20 1023943454</p>
                <p>
                  <span>
                {t("address")}:
                </span> 
                <a className='add' href='https://maps.app.goo.gl/j7zwdAtw2A282Xqr9'>
                الميناء الجاف 10th of Ramadan City, Egypt 44629
                </a>
                
                </p>
              </div>
            </Col>
            <Col md={6} sm={12} className="wow bounceInRight" data-wow-duration="2s" data-wow-delay="0.3s">
              <div>
                <form ref={form} onSubmit={sendEmail}>
                  <div className="d-flex">
                    <input type="text" name="name" placeholder={t("Name")} />
                    <input type="text" name="company" placeholder={t("company")} />
                  </div>
                  <div className="d-flex">
                    <input type="text" name="email" placeholder={t("email")} />
                    <input type="text" name="phone" placeholder={t("phone")} />
                  </div>
                  <textarea name="message" placeholder={t("message")}></textarea>
                  <button type="submit">{t("send")}</button>
                </form>
              </div>
            </Col>

          </Row>
        </Container>
      </section>

  )
}

export default Contact